/* global $, Modernizr */

const $search = $('.js-search');
const $searchInput = $('.js-search-input');
const $searchToggler = $('.js-search-toggler');

const SEARCH_FOCUS_DELAY = 300;

const search = {
  initialize() {
    if ($search.length) {
      this.createEvents();
    }
  },

  createEvents() {
    $searchToggler.on(Modernizr.touchevents ? 'touchstart' : 'click', (e) => {
      e.preventDefault();
      const isOpen = $search.hasClass('is-open');

      this.toggleSearch(isOpen);
    });
  },

  toggleSearch(isOpen) {
    if (!isOpen) {
      setTimeout(
        () => {
          if ($searchInput) {
            $searchInput.focus();
          }
        },
        SEARCH_FOCUS_DELAY,
      );
    }

    $search.toggleClass('is-open');

    $searchToggler
      .find('.search-toggler__text')
      .text(isOpen
        ? $searchToggler.find('.search-toggler__text').data('collapsed-text')
        : $searchToggler.find('.search-toggler__text').data('expanded-text'));
  },
};

export default search;
